import axios from 'axios'
import PORT_MAPPING_JSON from './port_mappings.json'

export const REACT_APP_BSS_APP_BACKEND = process.env.REACT_APP_BACKEND_URL
export const REACT_APP_BACKEND_WEBSOCKET_URL = process.env.REACT_APP_BACKEND_WEBSOCKET_URL
export const REACT_APP_BSS_APP_UI_DOMAIN = process.env.REACT_APP_BSS_APP_UI_DOMAIN
export const IS_PROD = process.env.REACT_APP_PROD
export const DEFAULT_SCRIPT_MODE = 'MWC_SCRIPT'
export const DEFAULT_AVATAR = 'Kiran_studio_20240103'
export const DEFAULT_LOCALE = 'en-IN'
export const HEYGEN_PING_INTERVAL = 120000
export const PORT_MAPPING: { [key: string]: string[] } = PORT_MAPPING_JSON
export const colorMapping = [
  { bg: '#F8EFFF', border: '#802DC8' },
  { bg: '#FFE5E7', border: '#FF4F58' },
  { bg: '#D6EAFF', border: '#0A7FFF' },
  { bg: '#FFF3EB', border: '#FF781F' },
  { bg: '#EDF7ED', border: '#43A047' },
  { bg: '#FFF8E1', border: '#FFB300' },
  { bg: '#E8EAF6', border: '#3F51B5' },
]
export const STREAMING = false
export const BackendAPI = axios.create({ baseURL: process.env.REACT_APP_BSS_APP_BACKEND, headers: { 'Content-Type': 'application/json' } })
